import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  TAwardVendorsRequestData,
  TResponsibleUser,
  TRFPBiddingData,
  TRFPCreateTimelineRequest,
  TRFPCreateTimelineResponseData,
  TRFPDetailsResponse,
  TRFPDocument,
  TRFPUpdateByVendorRequest,
  TRFPUploadFilesRequest,
  TUpdateResponsibleUsersRequestData,
  TUpdateResponsibleUsersResponseData,
  TRFPResponse,
  TRFPUpdateRequest,
  TFURequest,
  TGetRfpHealthSystemsRequest,
  TRFPUpdateRequestData
} from './types'
import { ResponseWithPagination } from 'constants/types'
import {
  AddHealthSystemRequest,
  AddHealthSystemResponse,
  AddHSToRfpRequest,
  DeleteHealthSystemRequest,
  IRfpHealthSystemWithHospitalsAdd
} from './Facilities/types'

const fetcher = new Fetcher({})

export const getRfpDetails = async (id: string) =>
  fetcher.request<unknown, TRFPDetailsResponse>({
    url: `${API_DICTIONARY.RFP}${id}/`,
    method: HTTP_METHODS.GET
  })

export const createRFP = async (data) =>
  fetcher.request<TRFPUpdateRequestData, TRFPResponse>({
    url: API_DICTIONARY.RFP,
    method: HTTP_METHODS.POST,
    successMessage: 'RFP has been successfully added.',
    data
  })

export const updateRFP = async (id, data, successMessage = '') =>
  fetcher.request<TRFPUpdateRequest, TRFPResponse>({
    url: `${API_DICTIONARY.RFP}${id}/`,
    method: HTTP_METHODS.PATCH,
    successMessage,
    data
  })

export const deleteCoUsersOnRFP = async (id, data, successMessage = '') =>
  fetcher.request<TFURequest, unknown>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.CO_USERS}`,
    method: HTTP_METHODS.DELETE,
    successMessage,
    data
  })
export const deleteVendorUsersOnRFP = async (id, data, successMessage = '') =>
  fetcher.request<TFURequest, unknown>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.VENDOR_USERS}`,
    method: HTTP_METHODS.DELETE,
    successMessage,
    data
  })

export const addCoUsersOnRFP = async (id, data, successMessage = '') =>
  fetcher.request<TFURequest, unknown>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.CO_USERS}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })
export const addVendorUsersOnRFP = async (id, data, successMessage = '') =>
  fetcher.request<TFURequest, unknown>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITY_USERS}${API_DICTIONARY.VENDOR_USERS}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })

export const updateVendorUsers = async (id, data, successMessage = '') =>
  fetcher.request<TRFPUpdateRequest, TRFPResponse>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.RFP_VENDOR_TEAM}`,
    method: HTTP_METHODS.PATCH,
    successMessage,
    data
  })

export const cancelRFP = async (id: string) =>
  fetcher.request<unknown, TRFPResponse>({
    url: `${API_DICTIONARY.RFP}${id}/`,
    method: HTTP_METHODS.DELETE
  })

export const uploadFiles = async (data) =>
  fetcher.request<TRFPUploadFilesRequest, TRFPDocument>({
    url: `${API_DICTIONARY.FILES}${API_DICTIONARY.RFP_DEFAULT_DOCUMENTS}`,
    method: HTTP_METHODS.POST,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })

export const createRFPTimelineAsync = async (id, data) =>
  fetcher.request<TRFPCreateTimelineRequest, TRFPCreateTimelineResponseData>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.TIMELINES}`,
    method: HTTP_METHODS.POST,
    data
  })

export const uploadVendorFiles = async (data) =>
  fetcher.request<TRFPUploadFilesRequest, TRFPDocument>({
    url: `${API_DICTIONARY.FILES}${API_DICTIONARY.RFP_VENDOR_DOCUMENTS}`,
    method: HTTP_METHODS.POST,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })

export const awardVendorsRequestAsync = async (
  id: string,
  data: TAwardVendorsRequestData
) =>
  fetcher.request<{ awarded_vendors: TAwardVendorsRequestData }, TRFPResponse>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.ARCHIVE}`,
    method: HTTP_METHODS.POST,
    data: { awarded_vendors: data }
  })

export const updateRFPByVendor = async (id, data, successMessage = '') =>
  fetcher.request<TRFPUpdateByVendorRequest, TRFPDocument>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.VENDOR_BIDDING}`,
    method: HTTP_METHODS.PATCH,
    successMessage,
    data
  })

export const getBiddingData = async (id: string) =>
  fetcher.request<unknown, TRFPBiddingData>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.VENDOR_BIDDING}`,
    method: HTTP_METHODS.GET
  })

export const startVendorsSelectionRequestAsync = async (
  id: string,
  data: Partial<TRFPDetailsResponse>
) =>
  fetcher.request<unknown, void>({
    url: `${API_DICTIONARY.RFP}${id}/`,
    method: HTTP_METHODS.PATCH,
    data
  })

export const updateResponsibleUsersRequestAsync = async (
  id: string,
  data: TUpdateResponsibleUsersRequestData,
  successMessage
) =>
  fetcher.request<
    TUpdateResponsibleUsersRequestData,
    TUpdateResponsibleUsersResponseData
  >({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.RESPONSIBLE_USERS}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })

export const updateCommonsResponsibleUsersRequestAsync = async (
  id: string,
  data: TUpdateResponsibleUsersRequestData,
  successMessage
) =>
  fetcher.request<
    TUpdateResponsibleUsersRequestData,
    TUpdateResponsibleUsersResponseData
  >({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.COMMONS_REASSIGNMENT}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })

export const getAvailableResponsibleUsersRequestAsync = async (id: string) =>
  fetcher.request<unknown, TResponsibleUser[]>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.RESPONSIBLE_USERS}`,
    method: HTTP_METHODS.GET
  })
export const getAvailableResponsibleCommonsUsersRequestAsync = async (
  id: string
) =>
  fetcher.request<unknown, ResponseWithPagination<TResponsibleUser>>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.COMMONS_RESPONSIBLE}`,
    method: HTTP_METHODS.GET
  })

export const deleteRfpHS = async (id, data, successMessage) =>
  fetcher.request<DeleteHealthSystemRequest, unknown>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.BULK_REMOVE}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })

export const getRfpHealthSystems = async (id, data) =>
  fetcher.request<
    TGetRfpHealthSystemsRequest,
    ResponseWithPagination<IRfpHealthSystemWithHospitalsAdd>
  >({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITIES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getHSList = async (id, data) =>
  fetcher.request<AddHealthSystemRequest, AddHealthSystemResponse>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HEALTH_SYSTEM}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const addHSToRfp = (id, data, successMessage) =>
  fetcher.request<AddHSToRfpRequest, AddHealthSystemResponse>({
    url: `${API_DICTIONARY.RFP}${id}/${API_DICTIONARY.FACILITIES}`,
    method: HTTP_METHODS.POST,
    data,
    successMessage
  })
